import React, { useEffect, useState } from "react";

import TrackingService from "@/service/Tracking";
import { inIframe } from "@/utils/getters";

import { AdSlot, Center } from "./styles";

export type AdvertisementProps = {
  adSlot: string;
  width: number;
  height: number;
  isPreview?: boolean;
};

const isInIframe = inIframe();

export const Advertisement: React.FC<AdvertisementProps> = (
  props: AdvertisementProps
): JSX.Element => {
  const { adSlot, width, height, isPreview } = props;
  const [loaded, setLoaded] = useState<boolean>(false);

  useEffect(() => {
    // Hint: Only one size (width, height) can be configured in la-interactive-admin-web, there could be more if required.
    window.adSSetup = {
      adSlotSizes: {
        [adSlot]: [
          {
            minWidth: 1,
            sizes: [[width, height]],
          },
        ],
      },
    };

    if (isInIframe) {
      // This adLib extension needs some preloaded scripts on the parent page.
      loadCorsFrameAdLib();
    }
  }, []);

  useEffect(() => {
    if (isPreview || !loaded) {
      return;
    }

    try {
      const adLibEvent = new CustomEvent("renderAd", { detail: adSlot });
      window.dispatchEvent(adLibEvent);
      TrackingService.getInstance().trackOnOutroImpression();
    } catch (e) {
      console.error("Could not dispatch renderAd adLibEvent", e);
    }
  }, [loaded]);

  const loadCorsFrameAdLib = () => {
    const script = document.createElement("script");
    script.src = "https://www.asadcdn.com/adlib/extensions/corsFrameAdLib.js";
    script.onload = () => setLoaded(true);
    document.body.appendChild(script);
  };

  return (
    <Center>
      <AdSlot
        isPreview={isPreview}
        forcePreview={!isPreview && !isInIframe}
        id={adSlot}
        style={{ width, height }}
        data-qa="outro.advertising.adSlot"
      />
    </Center>
  );
};
